export const ROOT_CONTAINER_ID = 'renderPage';

export const LOCK_MAIN_SCROLL_CLASSNAME = 'lock-main-scroll';
